export const PRODUCTS_RESULT_MODE = {
    TABLE: 'table',
    GRID: 'grid'
}

export const USER_CONFIG = {
    viewResultMode: PRODUCTS_RESULT_MODE.TABLE,
    favoriteProducts: []
}
